import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FullScreenLayout from "../../../components/FullScreenLayout";
import { Patient } from "../../../utils/api-objects/Patient";
import { getAllExamsByType } from "../../../utils/apis/emr-service";
import { useAuth } from "../../../utils/context/AuthContext";
import { usePatients } from "../../../utils/context/PatientsContext";
import { BucketFolder, PdfType } from "../../../utils/Enums";
import PdfCard from "../components/PdfCard";
import { PdfExam } from "../components/PdfExam";


const SharedFromUser = () => {
  const { auth } = useAuth()
  const role = auth.role
  const idToken = auth.idToken
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const patientId = searchParams.get("patient_id");
  const { patientsState } = usePatients()
  const patients = patientsState.patients

  const [patient, setPatient] = useState<Patient | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate()

  const [exams, setExams] = useState<PdfExam[]>()

  useEffect(() => {
    if (!patients) {
      setIsLoading(false);
      return;
    }
    const foundPatient = patients.find((p) => p.user_id === patientId);
    if (!foundPatient) return
    setPatient(foundPatient);

    if (!patientId || !idToken) return

    setIsLoading(false)

    getAllExamsByType(
      patientId,
      idToken,
      BucketFolder.UploadedFromUser,
      (exams) => {
        setExams(exams)
      },
      (error) => { console.log(error) },
    )

  }, [patients, patientId])

  if (isLoading) {
    return (
      <FullScreenLayout title="Caricamento...">
        <div className="w-full h-full flex flex-col items-center justify-center">
          <div>
            Attendi un attimo... <br />
            Stiamo caricando i dati del paziente
          </div>
        </div>
      </FullScreenLayout>
    );
  }

  if (!patient) {
    return (
      <FullScreenLayout title="Paziente non trovato">
        <div className="w-full h-full flex flex-col items-center justify-center">
          <div>
            Informazioni sul cliente non trovate
          </div>
          <button
            onClick={() => navigate("/platform-experts/customers")}
            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded"
          >
            Torna a clienti
          </button>
        </div>
      </FullScreenLayout>
    );
  }
  
  return (
    <FullScreenLayout
      title={`${patient.user_name} ${patient.user_family_name}`}
      backButtonText={`Torna a ${patient.user_name} ${patient.user_family_name}`}
      onBack={() => navigate(`/platform-experts/customers/single-customer?patient_id=${patientId}`)}
      showBackButton={true}
    >
      <div className="w-full flex flex-col space-y-6">
        {/* Subtitle */}
        <div className="font-bold text-[28px] md:text-[35px] leading-[35px] text-gray-900">
          Caricati da {patient.user_name}
        </div>
        
        {/* Files Grid */}
        <div className="w-full">
          <div className="flex flex-wrap gap-4">
            {
              exams && exams.length > 0 && exams.map((exam, index) => (
                <PdfCard key={index} exam={exam} pdfType={PdfType.Uploads} />
              ))
            }
          </div>
        </div>
      </div>
    </FullScreenLayout>
  )
}

export default SharedFromUser
